import { Injectable, EventEmitter } from '@angular/core';
import { firstValueFrom, Observable, ReplaySubject, BehaviorSubject, filter } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '@services/logging.service';
import { NavigationEnd, Router } from '@angular/router';
import { LicensingCountry } from '@models/licensingCountry.model';
import { RouterLink } from '../shared/_constants';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private apiBuildVersionNumber: string = null;
  private _jsonURL = 'assets/assemblyInfo.json';
  public navExpanded = true;

  public apiBuildVersionNumber$ = new ReplaySubject<string>(1);
  public isGridExtended: EventEmitter<boolean> = new EventEmitter();
  public gridExpanded = false;

  userCountry: LicensingCountry;
  private isLegacyStudySubject = new BehaviorSubject<boolean>(this.isLegacyStudy);
  public isLegacyStudy$ = this.isLegacyStudySubject.asObservable();
  private currentPathSubject = new BehaviorSubject<string>(window.location.pathname.toLowerCase());
  private readonly LEGACY_PATH_MARKERS: string[] = [
    RouterLink.LegacySearchStudies,
  ];
  private readonly LEGACY_QUERY_KEYS: string[] = [
    'legacy',
  ];
  constructor(
    private http: HttpClient,
    private logger: LoggingService,
    private router: Router,
  ) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => this.currentPathSubject.next(e.urlAfterRedirects.toLowerCase()));
  }
  

  public getJSON(): Observable<any> {
    if (window.location.host.endsWith('localhost:63758')) {
      return this.http.get(this._jsonURL);
    } else {
      return this.http.get('assemblyInfo.json');
    }
  }

  public async GetAPIBuildVersion(): Promise<string> {
    this.apiBuildVersionNumber = <string>await firstValueFrom(this.http.get(`/api/Navigation/GetAPIBuildVersion`, { responseType: 'text' })).catch(
      (e) => {
        this.logger.httpError(this.constructor.name, 'GetComments', e);
        if (e.status === 401) {
          this.router.navigate(['nostudyaccess']);
        }
      },
    );

    this.apiBuildVersionNumber$.next(this.apiBuildVersionNumber);
    return this.apiBuildVersionNumber;
  }

  setIsLegacyStudy(flag: boolean) {
    this.isLegacyStudySubject.next(flag);
  }
  get isLegacyStudy(): boolean {
    const path = this.currentPathSubject?.value ||
       (window.location.pathname?.toLowerCase() || '');
    return path.includes('/legacy');
  }
  
  public evaluateLegacyByRouting(url: string, queryParams: any): boolean {
    let legacy = this.LEGACY_PATH_MARKERS.some((m) => url.includes(m));
    if (!legacy) {
      legacy = this.LEGACY_QUERY_KEYS.some((k) => {
        const v = queryParams.get(k);
        return v !== null && ['1', 'true'].includes(v.toLowerCase());
      });
    }
    return legacy;
  }
}
